import { createApi } from '@reduxjs/toolkit/query/react';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { baseQueryWithAuth } from '../auth';
import { APIVersion } from '../../constants/keys';
import { transformWeatherForecasts } from '../../utils/weather';
import { WeatherForecast, WeatherForecastApi } from '../../types/weather';

const transformErrorResponse = (response: FetchBaseQueryError) =>
  (response as { data?: { errors?: unknown } }).data?.errors;

interface GetWeatherForecastResponse {
  results: WeatherForecastApi[];
}

// Weather
export const weatherApi = createApi({
  reducerPath: 'weatherApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getWeatherForecast: builder.query<WeatherForecast[], { lat: number; lon: number }>({
      query: ({ lat, lon }) => ({
        url: `/data-providers-api/${APIVersion}/weather/forecast`,
        params: { lat, lon },
      }),
      transformResponse: (data: GetWeatherForecastResponse) => transformWeatherForecasts(data.results),
      transformErrorResponse,
    }),
  }),
});

export const { useGetWeatherForecastQuery } = weatherApi;
